import Vue from "vue";
import VueRouter from "vue-router";
import Login from "@/pages/Login.vue";
import Home from "@/pages/Home.vue";
import WordBasics from "@/pages/WordBasics.vue";
import SelfTest from "@/pages/SelfTest.vue";
import LearningReport from "@/pages/LearningReport.vue";
import WordBook from "@/pages/WordBook.vue";
import MemoryCurve from "@/pages/MemoryCurve.vue";
import Help from "@/pages/Help.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: { requiresAuth: false },
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
    meta: { requiresAuth: true },
  },
  {
    path: "/word-basics",
    name: "WordBasics",
    component: WordBasics,
    meta: { requiresAuth: true },
  },
  {
    path: "/self-test",
    name: "SelfTest",
    component: SelfTest,
    meta: { requiresAuth: true },
  },
  {
    path: "/learning-report",
    name: "LearningReport",
    component: LearningReport,
    meta: { requiresAuth: true },
  },
  {
    path: "/word-book",
    name: "WordBook",
    component: WordBook,
    meta: { requiresAuth: true },
  },
  {
    path: "/memory-curve",
    name: "MemoryCurve",
    component: MemoryCurve,
    meta: { requiresAuth: true },
  },
  {
    path: "/help",
    name: "Help",
    component: Help,
    meta: { requiresAuth: false },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// 路由守卫 - 检查用户登录状态
router.beforeEach((to, from, next) => {
  // 直接检查localStorage，不依赖store状态
  const token = localStorage.getItem("userToken");
  const userInfoStr = localStorage.getItem("userInfo");
  
  // 更严格的登录状态检查
  let isLoggedIn = false;
  if (token && userInfoStr && userInfoStr !== "undefined" && userInfoStr !== "null") {
    try {
      const userInfo = JSON.parse(userInfoStr);
      isLoggedIn = !!(userInfo && typeof userInfo === 'object' && userInfo.id);
    } catch (e) {
      // 如果解析失败，清除无效数据
      console.log("用户信息解析失败，清除数据:", e);
      localStorage.removeItem("userToken");
      localStorage.removeItem("userInfo");
      isLoggedIn = false;
    }
  }
  
  console.log("路由守卫检查:", {
    to: to.path,
    from: from.path,
    requiresAuth: to.meta.requiresAuth,
    hasToken: !!token,
    hasUserInfo: !!userInfoStr,
    isLoggedIn,
    userInfoValid: userInfoStr !== "undefined" && userInfoStr !== "null"
  });

  // 如果需要认证但未登录
  if (to.meta.requiresAuth && !isLoggedIn) {
    console.log("需要登录，跳转到登录页");
    next("/login");
    return;
  } 
  
  // 如果已登录但访问登录页
  if (to.path === "/login" && isLoggedIn) {
    console.log("已登录用户访问登录页，跳转到首页");
    next("/home");
    return;
  } 
  
  // 允许访问
  console.log("允许访问:", to.path);
  next();
});

export default router;
